import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { settingsKeys } from '@/lib/queryKeys'
import type { VisitType } from '@/types/settings'

export function useVisitTypes() {
  return useQuery({
    queryKey: settingsKeys.visitTypes(),
    queryFn: () => providerApiClient.getVisitTypes(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useCreateVisitType() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Omit<VisitType, 'id'>) => providerApiClient.createVisitType(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.visitTypes() })
    },
  })
}

export function useUpdateVisitType() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<VisitType> }) =>
      providerApiClient.updateVisitType(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.visitTypes() })
    },
  })
}
